"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _IdeationColumn = _interopRequireDefault(require("./pipeline/IdeationColumn"));

var _widgetContainer = _interopRequireWildcard(require("../widget-container"));

var _widgetContainer2 = require("@insided/deprecated-preact-components/widget-container");

var _zod = require("zod");

var _axios = _interopRequireDefault(require("axios"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Pipeline column list wrapper with conditional height.
 *
 * Sets fixed height during loading to prevent CLS (Cumulative Layout Shift).
 * This optimization targets high-volume communities where performance matters most,
 * as they typically have many items and stricter UX requirements.
 */
var PipelineColumnList = function PipelineColumnList(_ref) {
  var children = _ref.children,
      maxHeight = _ref.maxHeight,
      isLoading = _ref.isLoading;
  var style = isLoading ? {
    height: maxHeight
  } : {
    maxHeight: maxHeight
  };
  return (0, _preact.h)("div", {
    className: "pipeline-col-list",
    style: style
  }, children);
};

var widgetName = 'ideation_pipeline';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-ideation_pipeline';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  title: _zod.z.string().optional(),
  subtitle: _zod.z.string().optional(),
  backgroundColor: _zod.z.string().optional(),
  backgroundColorDisplay: _zod.z.enum(['solid_color', 'none']).optional(),
  column_1: _zod.z.number(),
  column_2: _zod.z.number(),
  column_3: _zod.z.number(),
  selectedProductAreaIds: _zod.z.array(_zod.z.string()),
  categories: _zod.z.array(_zod.z.string()).optional(),
  maxHeight: _zod.z.number()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;
var EMPTY_COLUMN_DATA = {
  topics: [],
  totalTopicCount: 0,
  authors: {}
};

var IdeationPipeline = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IdeationPipeline, _Component);

  var _super = _createSuper(IdeationPipeline);

  function IdeationPipeline() {
    var _this;

    (0, _classCallCheck2.default)(this, IdeationPipeline);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: true,
      ideaStatusList: [],
      ideasFirstCol: EMPTY_COLUMN_DATA,
      ideasSecondCol: EMPTY_COLUMN_DATA,
      ideasThirdCol: EMPTY_COLUMN_DATA
    });
    return _this;
  }

  (0, _createClass2.default)(IdeationPipeline, [{
    key: "getIdeationStatusTitle",
    value: function getIdeationStatusTitle(ideaStatusId) {
      var items = this.state.ideaStatusList.filter(function (status) {
        return status.id === ideaStatusId.toString();
      });
      if (!items.length) return '';
      return items[0].name;
    }
  }, {
    key: "getIdeasForColumn",
    value: function () {
      var _getIdeasForColumn = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(ideationStatusTitle) {
        var _this$props, selectedProductAreaIds, categories;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, selectedProductAreaIds = _this$props.selectedProductAreaIds, categories = _this$props.categories;

                if (ideationStatusTitle) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", EMPTY_COLUMN_DATA);

              case 3:
                _context.next = 5;
                return IdeationPipeline.getIdeasWithFilters(ideationStatusTitle, selectedProductAreaIds, categories);

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getIdeasForColumn(_x) {
        return _getIdeasForColumn.apply(this, arguments);
      }

      return getIdeasForColumn;
    }()
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$props2, column_1, column_2, column_3, _yield$axios$get, data, titleFirstColumn, titleSecondColumn, titleThirdColumn, _yield$Promise$all, _yield$Promise$all2, ideasFirst, ideasSec, ideasThird;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, column_1 = _this$props2.column_1, column_2 = _this$props2.column_2, column_3 = _this$props2.column_3;
                _context2.next = 3;
                return _axios.default.get('/community/api/ideas/ideaStatuses');

              case 3:
                _yield$axios$get = _context2.sent;
                data = _yield$axios$get.data;

                if (data.result.length) {
                  _context2.next = 8;
                  break;
                }

                this.setState({
                  isLoading: false
                });
                return _context2.abrupt("return");

              case 8:
                this.setState({
                  ideaStatusList: data.result
                });
                titleFirstColumn = this.getIdeationStatusTitle(column_1);
                titleSecondColumn = this.getIdeationStatusTitle(column_2);
                titleThirdColumn = this.getIdeationStatusTitle(column_3);
                _context2.next = 14;
                return Promise.all([this.getIdeasForColumn(titleFirstColumn), this.getIdeasForColumn(titleSecondColumn), this.getIdeasForColumn(titleThirdColumn)]);

              case 14:
                _yield$Promise$all = _context2.sent;
                _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 3);
                ideasFirst = _yield$Promise$all2[0];
                ideasSec = _yield$Promise$all2[1];
                ideasThird = _yield$Promise$all2[2];
                this.setState({
                  isLoading: false,
                  ideasFirstCol: ideasFirst,
                  ideasSecondCol: ideasSec,
                  ideasThirdCol: ideasThird
                });

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "HeaderTag",
    get: function get() {
      return (0, _widgetContainer2.genericWidgetHeaderTagCalculator)(Boolean(this.props.title), Boolean(this.props.subtitle));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          title = _this$props3.title,
          subtitle = _this$props3.subtitle,
          backgroundColor = _this$props3.backgroundColor,
          backgroundColorDisplay = _this$props3.backgroundColorDisplay,
          hideSpacingWithUpperWidget = _this$props3.hideSpacingWithUpperWidget,
          paddingToTopAndBottom = _this$props3.paddingToTopAndBottom,
          titleColor = _this$props3.titleColor,
          titleColorDisplay = _this$props3.titleColorDisplay,
          subtitleColor = _this$props3.subtitleColor,
          subtitleColorDisplay = _this$props3.subtitleColorDisplay;
      var _this$props4 = this.props,
          column_1 = _this$props4.column_1,
          column_2 = _this$props4.column_2,
          column_3 = _this$props4.column_3,
          maxHeight = _this$props4.maxHeight;
      var _this$state = this.state,
          ideasFirstCol = _this$state.ideasFirstCol,
          ideasSecondCol = _this$state.ideasSecondCol,
          ideasThirdCol = _this$state.ideasThirdCol;
      return (0, _preact.h)(_widgetContainer.default, {
        config: {
          title: title,
          subtitle: subtitle,
          backgroundColor: backgroundColor,
          backgroundColorDisplay: backgroundColorDisplay,
          hideSpacingWithUpperWidget: hideSpacingWithUpperWidget,
          paddingToTopAndBottom: paddingToTopAndBottom,
          titleColor: titleColor,
          titleColorDisplay: titleColorDisplay,
          subtitleColor: subtitleColor,
          subtitleColorDisplay: subtitleColorDisplay
        },
        widgetName: widgetName
      }, (0, _preact.h)(PipelineColumnList, {
        maxHeight: maxHeight,
        isLoading: this.state.isLoading
      }, (0, _preact.h)(_IdeationColumn.default, {
        columnData: ideasFirstCol,
        statusTitle: this.getIdeationStatusTitle(column_1),
        maxHeight: maxHeight,
        HeaderTag: this.HeaderTag,
        isLoading: this.state.isLoading
      }), (0, _preact.h)(_IdeationColumn.default, {
        columnData: ideasSecondCol,
        statusTitle: this.getIdeationStatusTitle(column_2),
        maxHeight: maxHeight,
        HeaderTag: this.HeaderTag,
        isLoading: this.state.isLoading
      }), (0, _preact.h)(_IdeationColumn.default, {
        columnData: ideasThirdCol,
        statusTitle: this.getIdeationStatusTitle(column_3),
        maxHeight: maxHeight,
        HeaderTag: this.HeaderTag,
        isLoading: this.state.isLoading
      })));
    }
  }], [{
    key: "getIdeasWithFilters",
    value: function () {
      var _getIdeasWithFilters = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(ideaStatusName, selectedProductAreaIds, categories) {
        var _res$data;

        var filters, categoryFilter, res;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                filters = {
                  ideationStatus: [ideaStatusName],
                  productArea: selectedProductAreaIds
                };
                categoryFilter = categories ? {
                  category: categories
                } : {};
                _context3.next = 4;
                return _axios.default.get('/ideas/topics', {
                  params: {
                    filters: _objectSpread(_objectSpread({}, filters), categoryFilter),
                    sort: 'votes',
                    limit: 10
                  }
                });

              case 4:
                res = _context3.sent;
                return _context3.abrupt("return", (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : EMPTY_COLUMN_DATA);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getIdeasWithFilters(_x2, _x3, _x4) {
        return _getIdeasWithFilters.apply(this, arguments);
      }

      return getIdeasWithFilters;
    }()
  }]);
  return IdeationPipeline;
}(_preact.Component);

var _default = IdeationPipeline;
exports.default = _default;